export const APP_SOURCE = "app";
export const APP_URL = "https://app.planwellguide.com";

export const AUTH: string = "/auth";
export const DASHBOARD: string = "/";
export const LOGIN: string = `${AUTH}/log-in`;
export const COMPLETION: string = `${AUTH}/completion`;
export const CONFIRMATION: string = `${AUTH}/confirmation`;
export const RECOVER_EMAIL: string = `${AUTH}/recover-email`;
export const FORGOT_PASSWORD: string = `${AUTH}/forgot-password`;
export const REGISTRATION: string = `${AUTH}/registration`;
export const RESET_PASSWORD: string = `${AUTH}/reset-password`;
export const HANDLER: string = `${AUTH}/handler`;
export const ROUTE_404: string = `/404`;
export const CONTACT_US: string = `/contact-us`;
export const TERMS_OF_SERVICE: string = `/terms-of-service`;
export const PRIVACY_POLICY: string = `/privacy-policy`;

export const PROFILE: string = `/profile`;
export const PROFILE_GENERAL: string = `${PROFILE}/general`;
export const PROFILE_ACCOUNT: string = `${PROFILE}/account`;
export const PROFILE_BILLING: string = `${PROFILE}/billing`;
export const PROFILE_NOTIFICATIONS: string = `${PROFILE}/notifications`;
export const BILLING: string = "/billing";
export const DEMOGRAPHICS: string = `/demographics`;
export const PREP_FQ: string = `/prep-fq`;
export const PREP_FQ_REPORT: string = `${PREP_FQ}/report`;
export const PREP_FQ_PDF: string = `${PREP_FQ}/pdf`;
export const PREP_FQ_PDF_VIEWER: string = `${PREP_FQ}/pdf-viewer`;
export const PREP_FQ_INTRO: string = `${PREP_FQ}/introduction`;
export const PREMIUM: string = `/premium`;
export const PREMIUM_DASHBOARD: string = `${PREMIUM}/dashboard`;
export const PREMIUM_PRIORITIES: string = `${PREMIUM}/priorities`;
export const JOURNAL_ENTRIES: string = `${PREMIUM_DASHBOARD}/journal-entries`;
export const ADD_CARD_DETAILS: string = `/add-card`;

export const ASIP: string = `/asip`;
export const ASIP_INTRO: string = `/intro`;
export const ASIP_CONCLUSION: string = `/conclusion`;
export const ASIP_OVERVIEW: string = `/overview`;
export const ASIP_OVERVIEW_NEW: string = `/overview-new`;

export const ASIP_PROFILES: string = `${ASIP}/profiles`;
export const ASIP_REMINDER: string = `asip-reminder`;
export const DEAR_DR_VIEWER: string = `/dear-doctor`;
export const DEAR_SDM_VIEWER: string = `/dear-sdm`;
export const DEAR_DR_PDF: string = `/dear-doctor-pdf`;
export const DEAR_SDM_PDF: string = `/dear-sdm-pdf`;
export const ASIP_PLAN: string = `/asip-new`;
export const ASIP_PLAN_NEW: string = `/plan`;
export const GUIDES: string = "/guides";
export const ADD_CARD_URL: string = `/add-card`;
export const ONBOARD_PROFILE: string = `/onboarding-profile`;
export const ADDED_CARD_REDIRECT: string = PROFILE_BILLING;

export const REQUEST_WALLET_CARD: string = `/request-card`;

export const PAYMENT: string = "/payment";
export const PAYMENT_SUCCESS: string = `${PAYMENT}/success`;

export const EXPLORE_PDF: string = `/explore-pdf`;
export const EQUIP_REPRESENT_PDF: string = `/equip-represent-pdf`;
export const ENTRUST_DEAR_LAWYER_PDF: string = `/entrust-dear-lawyer-pdf`;
export const EMPOWER_CAREGIVER_REPORTS_PDF: string = `/empower-caregiver-reports-pdf`;
export const EMPOWER_PATIENT_REPORTS_PDF: string = `/empower-patient-reports-pdf`;
export const DEAR_ICU_TEAM_PDF: string = `/dear-icu-team-pdf`;
export const DEAR_SUPPORT_TEAM_PDF: string = `/dear-support-team-pdf`;
export const EQUIP_PERSONAL_DIRECTIVE_PDF: string = `/equip-personal-directive-pdf`;

export const GET_ACCESS: string =
  "https://forms.zohopublic.com/planwellguide/form/AdditionalGuidesAccessEntrustingEnacting/formperma/xKR-f-_1oQZGfITRVrh28wRgqFybPD9nhbN0ph2CnNM";
export const INTENT_REDIRECT_URL: string = `${APP_URL}${ADDED_CARD_REDIRECT}`;

export const MY_DOCUMENTS: string = "/my-documents";
export const SHARED_DOCUMENTS: string = "/shared-documents";

export const GUIDES_ENHANCE: string = "/guides/enhance";
export const GUIDES_ENSURE: string = "/guides/ensure";
export const GUIDES_EQUIP: string = "/guides/equip";
export const QUIZ: string = "/quiz";
export const GUIDES_EXPLORE: string = "/guides/explore";
export const GUIDES_ENTRUST: string = "/guides/entrust";
export const GUIDES_ENACT: string = "/guides/enact";
export const GUIDES_CAREGIVER: string = "/guides/caregiver";
export const GUIDES_PATIENT: string = "/guides/patient";
export const PWG_PRODUCTS: string = "/products";
export const ENHANCE_GUEST_QUIZ: string = "/enhancing-quiz";
export const ENHANCE_QUIZ: string = `${GUIDES_ENHANCE}${QUIZ}`;
export const ENHANCE_DASHBOARD: string = `${GUIDES_ENHANCE}/dashboard`;
export const ENHANCE_PDF: string = `${GUIDES_ENHANCE}/pdf`;
export const ENHANCE_PDF_VIEWER: string = `${GUIDES_ENHANCE}/pdf-viewer`;
export const ENHANCE_PRIORITIES: string = `${ENHANCE_DASHBOARD}/priorities`;
export const ENHANCE_JOURNAL_ENTRIES: string = `${ENHANCE_DASHBOARD}/journal-entries`;
